// Búsqueda en listas desplegables (antd Select): filtra mientras se escribe,
// sin distinguir mayúsculas/minúsculas ni tildes.

const normalizar = (texto) =>
  String(texto ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()

// Extrae el texto visible de una opción (label o children, aunque sea JSX)
const textoDeNodo = (nodo) => {
  if (nodo == null || typeof nodo === 'boolean') return ''
  if (typeof nodo === 'string' || typeof nodo === 'number') return String(nodo)
  if (Array.isArray(nodo)) return nodo.map(textoDeNodo).join('')
  return textoDeNodo(nodo.props?.children)
}

export const filtrarOpcionSelect = (input, option) =>
  normalizar(textoDeNodo(option?.label ?? option?.children)).includes(normalizar(input))

export const busquedaSelectProps = {
  showSearch: true,
  filterOption: filtrarOpcionSelect,
  notFoundContent: 'Sin resultados',
  // La lista siempre se despliega hacia abajo (sin voltearse hacia arriba)
  placement: 'bottomLeft',
  dropdownAlign: { overflow: { adjustX: false, adjustY: false } },
}

// Para inputs dentro de dropdownRender: evita que el Select capture las teclas
export const detenerTeclasSelect = (e) => e.stopPropagation()
